module.exports = __webpack_public_path__ + "static/media/front.88006415.jpg";